// faqsByRoute.js

const faqsByRoute = {

  // -------------------------
  // Home
  // -------------------------
  "/": {
    titleColor: "#FF6557",
    items: [
      {
        q: "What eligibility is required for pilot training in India?",
        a: "To enrol in pilot training in India, students must have completed 10+2 with Physics and Mathematics from a recognised board. Candidates should also meet the DGCA Class 2 and Class 1 medical fitness standards and be at least 17 years old at the time of admission. MH Cockpit guides students through every step of the eligibility and medical clearance process for pilot training."
      },
      {
        q: "How to apply for pilot training at MH Cockpit?",
        a: <>
          Applying for pilot training at MH Cockpit is simple. <span className="text-blue-600"><a href="/contact" title="Contact">Visit our official website</a></span> and fill out the course application form. After submission, our admissions team will contact you for eligibility verification, entrance guidance, and medical evaluation support. You can also apply directly at our Chennai campus or through our official admission helpline.
        </>
      },
      {
        q: "Does MH Cockpit provide job placement support after course completion?",
        a: "Yes, MH Cockpit offers 100% placement assistance through its extensive network of aviation partners. Our dedicated placement cell supports students with interviews, resume preparation, and grooming sessions. Graduates receive opportunities in both domestic and international aviation sectors, including airlines, airports, and ground-handling companies."
      },
      {
        q: "How to select the right aviation course after 12th?",
        a: "Choosing the right aviation course depends on your career goals. If you aspire to become a pilot or flight instructor, pilot training is ideal. For those interested in airport operations, management, or hospitality, courses like BBA or BSc in Aviation Management are suitable. MH Cockpit provides expert counselling to help students pick the most rewarding aviation path after 12th."
      },
      {
        q: "What is the scope of BSc Aviation in India?",
        a: <>
          A <span className="text-blue-600"><a href="/training/bsc-aviation" title="BSc Aviation">BSc Aviation</a></span> offers diverse career opportunities in flight operations, airline management, air traffic control, logistics, and aviation safety. Graduates can work with airlines, airport authorities, or pursue higher studies in aeronautical science and management. MH Cockpit’s industry-integrated program ensures students develop the technical and managerial skills required to thrive in the modern aviation sector.
        </>
      },
      {
        q: "What are the career options in the aviation industry after graduation?",
        a: "After graduation, aviation students can pursue careers as pilots, ground staff, flight dispatchers, cabin crew, air traffic controllers, airport managers, or aviation safety officers. With the growing Indian aviation market, there’s an increasing demand for skilled professionals. MH Cockpit’s career-focused training and placement support help students enter top aviation organisations with confidence."
      },
    ],
  },

  // -------------------------
  // Innovation
  // -------------------------
  "/innovation": {
    titleColor: "#FF6557",
    items: [
      {
        q: "How does innovation improve a student’s learning experience?",
        a: "Innovation makes aviation training more practical and easier to understand. At MH Cockpit, tools like high-fidelity simulators, digital learning platforms, and scenario-based activities help students learn faster and apply concepts in real situations. This improves confidence, decision-making, and overall skill development."
      },
      {
        q: "Does MH Cockpit provide both simulator and real-aircraft training?",
        a: "Yes. MH Cockpit offers both advanced simulator training and real fixed-wing aircraft sessions. Students first practice safely in our simulators and then apply those skills in actual aircraft. This blended method helps them build strong flying skills and better situational awareness."
      },
      {
        q: "What makes MH Cockpit different from traditional aviation training institutes?",
        a: "MH Cockpit uses modern, technology-supported training instead of traditional classroom-only methods. Our programs combine digital tools, immersive simulators, structured practice modules, and updated aviation standards. This helps students learn through real scenarios and gain skills that match today’s aviation industry needs."
      },
      {
        q: "How does innovation help aviation students become job-ready?",
        a: "Innovation helps students build the skills employers expect. At MH Cockpit, students train with industry-standard simulators, real-time performance tracking, and scenario-based sessions. These methods develop strong technical skills, better decision-making, and confidence in handling aviation challenges, making them job-ready for airline and aviation careers."
      },
      {
        q: "Does MH Cockpit collaborate with universities or industry partners for innovation?",
        a: "Yes. MH Cockpit collaborates with several universities and aviation partners to support modern training setups, simulator infrastructure, and updated learning systems. These partnerships help us stay aligned with industry standards and provide students with relevant, future-ready training."
      },
    ],
  },

  // -------------------------
  // Colleges
  // -------------------------
  "/colleges": {
    titleColor: "#FF6557",
    items: [
      {
        q: "What is the eligibility for BSc Aviation?",
        a: <>Most colleges want students to have at least 10+2 (or the same level) with Physics and Math as their main subjects. Depending on the school, they may also want a minimum grade point average (usually  50% above). Some colleges accept NIOS or equivalent qualifications, while others require entrance tests or interviews. Different colleges have different requirements, so please <span className='text-blue-500 underline underline-offset-2'><a href='/contact' title="Contact">contact us</a></span> to find out if you meet the requirements for a specific program.</>
      },
      {
        q: "Maths & Physics compulsory for aviation courses?",
        a: <>Maths and physics are the foundation for comprehending flight mechanics, navigation, and aircraft systems; they are required for the majority of technical aviation programs, including BSc. Aviation, AME, and Aeronautical Engineering. Both subjects might not be required for some management programs, such as the BBA Aviation program. You can <span className='text-blue-500 underline underline-offset-2'><a href='/contact' title="Contact">reach us</a></span> here for individualised advice regarding your eligibility for the course.</>
      },
      {
        q: "Education Loan available for aviation courses?",
        a: <>Yes, accredited aviation programs offered by reputable universities and colleges qualify for education loans. Generally speaking, banks only grant loans to organisations that satisfy legal and academic requirements. <span className='text-blue-500 underline underline-offset-2'><a href='/contact' title="Contact">Get in touch with our staff</a></span> if you require help with loan documentation or options.</>
      },
      {
        q: "Are internships included in aviation college programs?",
        a: <>Particularly for AME, BSc. Aviation and Aviation Management courses, the majority of accredited aviation colleges incorporate internships, industry exposure, or hands-on training into their curricula. The availability of internships varies by institution. For information about internships specific to our program, <span className='text-blue-500 underline underline-offset-2'><a href='/contact' title="Contact">get in touch with us</a></span>.</>
      },
      {
        q: "Can international students apply to aviation courses in India?",
        a: <>Yes, international students can apply to accredited aviation programs in India as long as they meet the requirements and send in the right papers. Some colleges have help desks for students from other countries. Please <span className='text-blue-500 underline underline-offset-2'><a href='/contact' title="Contact">get in touch with us</a></span> if you need help with international admissions.</>
      },
    ],
  },

  // -------------------------
  // Vels University
  // -------------------------
  "/colleges/vels-university": {
    titleColor: "#FF6557",
    items: [
      {
        q: "What is unique about the aviation programs at VELS University?",
        a: "VELS offers a comprehensive range of aviation courses from BSc Aviation and BSc Aeronautical Science (technical tracks) to BBA Aviation Management, MBA Aviation, and specialised diplomas in cabin crew, airport management, and aircraft maintenance, all combining UGC-approved academics with practical exposure like IAF veteran training and MRO internships on a single Chennai campus.​"
      },
      {
        q: "What is the placement record and salary range for VELS aviation students?",
        a: "VELS reports solid placements with aviation students securing roles at IndiGo, Air India, and AAI; packages range from ₹2-4 LPA entry-level to highs of ₹12 LPA campus-wide, with 40-90% placement rates in batches and strong internship conversion via centralised drives."
      },
      {
        q: "Does VELS have flight simulators and aviation labs?",
        a: "Yes. Facilities include flight simulators for cockpit training, aircraft systems/navigation labs, physics/electronics setups, ATC familiarisation, MRO workshops, and cabin crew studios, supporting practicals across technical and management programs."
      },
      {
        q: "Can international or NRI students join VELS aviation programs?",
        a: "Yes. VELS accepts NRI/international applicants meeting equivalent 10+2/graduation eligibility, with dedicated admission processes, documentation, and fee structures handled via the international office for UG/PG/diploma courses."
      },
      {
        q: "Does the curriculum match DGCA ground school for CPL?",
        a: "Yes. BSc Aviation maps core DGCA subjects like air navigation, meteorology, regulations, and technical general, providing a solid base that reduces prep time for CPL exams while aligning other programs with industry standards for ops and management roles."
      },
    ],
  },

  // -------------------------
  // Alliance University
  // -------------------------
  "/colleges/alliance-university": {
    titleColor: "#FF6557",
    items: [
      {
        q: "What is unique about the aviation programs at Alliance University?",
        a: "Alliance University offers both BSc Aviation and BBA Aviation Management, letting students choose between a technical science track (for cockpit/engineering/operations) and a management track (for airport and airline business roles), all on a NAAC‑graded, NIRF‑ranked private university campus in Bangalore with strong industry exposure.​"
      },
      {
        q: "Are the BSc Aviation and BBA Aviation Management degrees recognised in India and abroad?",
        a: "Yes. Both programs are offered under Alliance University, a UGC‑recognised private university with AICTE‑approved programs and internationally benchmarked business accreditations (IACBE/AACSB membership on the management side), making the degrees valid for higher studies and aviation careers in India and many overseas markets.​"
      },
      {
        q: "Does the BSc Aviation program make me a pilot directly?",
        a: "No degree by itself can grant a pilot licence; BSc Aviation at Alliance builds DGCA‑relevant ground knowledge in areas such as navigation, meteorology and regulations, but students still need to complete CPL flying hours and attempt DGCA exams at an approved flying school to become commercial pilots.​"
      },
      {
        q: "Can international or NRI students join these aviation programs?",
        a: "Yes. Alliance University accepts NRI and international students for its undergraduate degrees. Such applicants must meet the equivalent 10+2 eligibility requirements and follow the dedicated international admission and fee norms outlined by the university’s admissions office.​"
      },
      {
        q: "Is the curriculum aligned with the aviation industry's and DGCA's expectations?",
        a: "The BSc Aviation program is designed around core aeronautical and operational subjects that mirror DGCA ground‑school domains, and both BSc and BBA curricula are framed with input from industry partners and accreditation bodies, helping graduates match the competency expectations of airlines, airports and regulatory‑aligned roles.​"
      },
    ],
  },

  // -------------------------
  // Bharath University
  // -------------------------
  "/colleges/bharath-university": {
    titleColor: "#FF6557",
    items: [
      {
        q: "What is unique about the BSc Aviation and BSc Aeronautical Science programs at Bharath University?",
        a: "Bharath offers both as specialised science degrees via MH Cockpit collaboration, with B.Sc Aviation focusing on flight operations, navigation, and CPL ground-school foundations, while B.Sc Aeronautical Science blends aircraft systems with airline business for cabin/ops roles, delivered on a NAAC-accredited campus with industry-linked practicals.​"
      },
      {
        q: "Are these B.Sc degrees recognised in India and abroad?",
        a: "Yes. Bharath Institute of Higher Education and Research is UGC-recognised with NAAC grading, making the degrees valid for higher studies, aviation jobs in airlines/airports/MROs, and international opportunities, supported by the university's global partnerships and research status.​"
      },
      {
        q: "What eligibility is required to join B.Sc Aviation or B.Sc Aeronautical Science at Bharath?",
        a: "Applicants need 10+2 with Physics (Science stream preferred) or equivalent 3-year Polytechnic Engineering Diploma from a recognised board/university, typically with 50% aggregate as per norms (relaxations for reserved categories apply).​"
      },
      {
        q: "Does B.Sc Aviation at Bharath make me a pilot directly?",
        a: "No degree grants a pilot licence alone; Bharath's B.Sc Aviation provides DGCA-aligned ground training in navigation, meteorology, regulations, and flight performance, but CPL requires separate flying hours and exams at DGCA-approved schools.​"
      },
      {
        q: "What kind of internships will I get during the course?",
        a: "From second year, students access internships via MH Cockpit network at airports, airlines, AAI partners, and MROs, covering ground ops, dispatch, ramp handling, and maintenance observation under supervision.​"
      },
    ],
  },

  // -------------------------
  // Crescent University
  // -------------------------
  "/colleges/crescent-university": {
    titleColor: "#FF6557",
    items: [
      {
        q: "Is this BSc Aviation degree recognised in India and abroad?",
        a: "Yes. The program is offered by B.S. Abdur Rahman Crescent Institute of Science & Technology, a NAAC A+ institution with UGC recognition and AICTE‑aligned curricula, making the degree valid for higher studies and aviation jobs in India and many international markets.​"
      },
      {
        q: "Does BSc Aviation at Crescent make me a pilot directly?",
        a: "No degree alone can grant a pilot licence; Crescent’s B.Sc Aviation provides DGCA‑aligned ground‑school in subjects like Navigation, Meteorology and Regulations, and you must still complete CPL flying hours and DGCA exams at an approved flying school to become a commercial pilot.​"
      },
      {
        q: "What are the main job roles after completing BSc Aviation at Crescent?",
        a: "Graduates typically work as flight dispatchers, flight operations officers, ground operations executives, maintenance/operations technicians, safety & quality assistants, and can later move into CPL training or ATC/ANS roles via separate exams.​"
      },
      {
        q: "Does Crescent have flight simulators and aviation labs?",
        a: "Yes. The campus includes in‑house flight simulators, aircraft systems and navigation labs, and physics/electronics laboratories, giving students hands‑on exposure aligned with what they study in class.​"
      },
      {
        q: "Does the curriculum match DGCA ground‑school subjects for CPL?",
        a: "Yes. Key DGCA ground‑school areas—Air Navigation, Meteorology, Air Regulations and Technical General—are mapped into the Crescent B.Sc Aviation curriculum, giving students a strong conceptual base before they attempt DGCA exams at flying schools. This alignment reduces the time and effort required later during CPL theory preparation.​"
      },
    ],
  },

  // -------------------------
  // Ganpat University
  // -------------------------
  "/colleges/ganpat-university": {
    titleColor: "#FF6557",
    items: [
      {
        q: "Is the BBA Aviation Management degree from Ganpat University recognised in India and abroad?",
        a: "Yes. Ganpat University is a recognised private university. The degree is valid for higher studies and jobs in airport operations, airline services, and ground handling across India. The program runs in academic collaboration with MH Cockpit at campuses in Gujarat and Goa.​"
      },
      {
        q: "What job roles can I expect after completing BBA Aviation Management at Ganpat University?",
        a: "Graduates target roles such as Airport Executive, Ground Handling Supervisor, Airline Customer Service Executive, and Cargo & Logistics Executive. With experience, they can progress to Airport Manager, Airline Operations Manager, Air Cargo Supervisor, and similar supervisory positions.​"
      },
      {
        q: "Is this program suitable if I do not want to become a pilot?",
        a: "Yes. This is a management program focused on airport operations, ground handling, passenger services, and logistics rather than technical flight roles. Students from any stream with a minimum 50% marks in 10+2 are eligible to apply."
      },
      {
        q: "What practical training and industry exposure does the program offer?",
        a: "Through MH Cockpit collaboration, students get internships and observational training at airports, airlines, and ground handlers, plus live projects on terminal management and turnaround coordination. Placement support includes CV preparation, mock interviews, and career counselling."
      },
      {
        q: "What is the admission process for BBA Aviation Management at Ganpat University for 2026–2027?",
        a: "Admissions are through the MH Cockpit online portal. After application and eligibility verification (10+2, any stream, minimum 50%), candidates attend counselling. Offers are made based on eligibility and seat availability, followed by confirmation and enrolment in line with university timelines."
      },
    ],
  },


  // -------------------------
  // Sanskriti University
  // -------------------------
  "/colleges/sanskriti-university": {
    titleColor: "#FF5959",
    items: [
      {
        q: "What aviation courses are offered at Sanskriti University?",
        a: "Sanskriti University offers a range of aviation programs, including BSc Aviation, BSc Aeronautical Science, BBA Aviation Management, BSc Aircraft Maintenance Engineering, BTech Aeronautical Engineering, BTech Aerospace Engineering, MBA Aviation & Airport Management, and a certificate program in Cabin Crew."
      },
      {
        q: "What qualifications are required to apply for aviation courses at Sanskriti University?",
        a: "To apply for aviation courses at Sanskriti University, students must meet program-specific academic requirements. Management and service-oriented programs accept candidates from any stream after 10+2, while science and engineering aviation programs require Physics, Mathematics, or PCM at the 10+2 level. Postgraduate aviation programs require a recognised bachelor’s degree. Minimum eligibility is generally 50% aggregate marks, subject to program norms."
      },
      {
        q: "Are aviation degrees from Sanskriti University recognised?",
        a: "Yes. All aviation programs at Sanskriti University are offered under a UGC-recognised university framework and follow established academic and regulatory standards, making them valid for higher studies and aviation-related careers in India."
      },
      {
        q: "Does completing an aviation course at Sanskriti University make me a pilot or cabin crew directly?",
        a: "No. Academic aviation courses provide foundational knowledge and operational understanding. Becoming a commercial pilot or cabin crew requires separate airline or DGCA-approved training, medical clearance, and regulatory examinations."
      },
      {
        q: "What career opportunities are available after aviation courses at Sanskriti University?",
        a: "Graduates can pursue roles across airports, airlines, aviation services, engineering organisations, MROs, cargo operations, and aviation administration. Career outcomes vary by program, certifications, individual performance, and industry demand."
      },
    ],
  },

  // -------------------------
  // Bishop Heber College
  // -------------------------
  "/colleges/bishop-heber-college": {
    titleColor: "#FF5959",
    items: [
      {
        q: "What eligibility is required to join B.Sc Aviation or BBA Aviation & Ground Handling?",
        a: "Applicants must have completed 10+2 from a recognised board with a minimum of 50% aggregate marks. B.Sc Aviation generally requires Physics in the 12th standard or an equivalent Polytechnic Engineering Diploma, while BBA Aviation & Ground Handling is open to students from any stream."
      },
      {
        q: "Does B.Sc Aviation make me a pilot directly?",
        a: "No. A degree alone does not grant a pilot licence. B.Sc Aviation provides ground-level knowledge in navigation, meteorology, and aviation regulations, but becoming a commercial pilot requires separate flying training and regulatory exams at approved flying schools."
      },
      {
        q: "What are the main job roles after completing these aviation programs?",
        a: "Graduates typically work as Flight Dispatchers, Airport Operations Executives, Ground Handling Supervisors, Airline Customer Service Executives, Cargo Operations Officers, and Flight Operations Coordinators, depending on the program completed."
      },
      {
        q: "What kind of internships will I get during the course?",
        a: "Students usually receive internship opportunities from the second year onwards with airports, airlines, and ground-handling organisations, focusing on ramp operations, dispatch support, terminal operations, and customer service under supervision."
      },
      {
        q: "What subjects are covered semester-wise in these programs?",
        a: "B.Sc Aviation covers subjects such as flight mechanics, air navigation, meteorology, aviation safety, and regulations across six semesters, while BBA Aviation & Ground Handling focuses on airport operations, ground handling, customer service, airline administration, and aviation law through projects and case studies."
      },
    ],
  },

  // -------------------------
  // Sasurie College
  // -------------------------
  "/colleges/sasurie-college": {
    titleColor: "#FF5959",
    items: [
      {
        q: "What are the eligibility criteria for BBA (Specialisation in Aviation) at Sasurie College?",
        a: "To be eligible for the BBA (Specialisation in Aviation) program, candidates must have completed 10+2 from a recognised board in any stream (Arts, Commerce, or Science) with a minimum aggregate of 50% marks. This makes it accessible for students from diverse academic backgrounds interested in aviation management.​"
      },
      {
        q: "What are the key focus areas in the BBA Aviation program?",
        a: "The program emphasises practical aviation knowledge, covering airport and terminal operations management, airline ground handling and turnaround coordination, aviation safety, security, and regulatory awareness, passenger services and customer experience management, as well as air cargo, logistics, and aviation support services. It prepares students for non-technical roles in the aviation industry.​"
      },
      {
        q: "What career opportunities are available after completing the BBA Aviation?",
        a: "Graduates can pursue general management roles like Business Development Executive, Marketing Coordinator, Operations Executive, HR Executive, or Administration Manager across industries. In aviation-specific roles, options include Airport Operations Executive, Airline Operations Coordinator, Ground Handling Supervisor, Passenger Service Manager, Air Cargo & Logistics Executive, Customer Experience Manager, or Aviation Administration Executive.​"
      },
      {
        q: "What is the admission process for BBA Aviation in 2026–2027?",
        a: "The admission process involves online application submission through the MH Cockpit admission portal, eligibility verification based on academic background, counselling or interaction to assess suitability, offer of admission based on eligibility and seat availability, and confirmation/enrolment as per university timelines. Applicants from areas like Tirupur District, Vijayamangalam, Erode, Perundurai, Chennimalai, and Kangeyam are encouraged to consult an admissions counselor.​"
      },
      {
        q: "What facilities and industry exposure do BBA Aviation students get at Sasurie College?",
        a: "Students benefit from business and aviation management classrooms, industry-oriented case studies and simulations, training modules on airport and airline workflows, and support for communication skills, grooming, and professional development. Industry exposure includes aviation management modules, internships with airports and airlines, case studies, applied projects, academic mentoring, career guidance, resume preparation, interview support, and placement assistance based on performance.​"
      },
    ],
  },

  // -------------------------
  // Jamal Mohamed College
  // -------------------------
  "/colleges/jamal-mohamed-college": {
    titleColor: "#FF5959",
    items: [
      {
        q: "Is the BBA Aviation Management degree recognised in India and abroad?",
        a: "Yes. As an autonomous college under Bharathidasan University with UGC recognition, the degree is valid for higher studies, aviation management jobs in airlines/airports/ground handlers, and international opportunities through MH Cockpit's industry network.​"
      },
      {
        q: "What are the main job roles after completing BBA Aviation Management at Jamal Mohamed?",
        a: "Graduates target airport duty officers, ground handling supervisors, airline customer service/ticketing execs, operations coordinators, and cargo/logistics roles across airlines, airports, and service providers."
      },
      {
        q: "Can international or NRI students join the BBA Aviation Management program?",
        a: "Yes. The college accepts NRI/international applicants with equivalent 10+2/diploma eligibility, processed via dedicated admissions with required documentation and fee structures.​"
      },
      {
        q: "Is the curriculum aligned with aviation industry standards?",
        a: "Yes. The program maps to skills demanded by airlines/airports like IATA/AAI guidelines for ground handling, customer service, and ops compliance, preparing students for real supervisory roles.​"
      },
      {
        q: "Can BBA Aviation Management graduates pursue an MBA Aviation later?",
        a: "Absolutely. Graduates qualify for MBA Aviation/Management or specialised master's, with ground ops experience ideal for advanced roles in airport strategy, airline leadership, or logistics.​"
      },
    ],
  },

  // -------------------------
  // Kalasalingam University
  // -------------------------
  "/colleges/kalasalingam-university": {
    titleColor: "#FF5959",
    items: [
      {
        q: "Can I pursue a Commercial Pilot Licence (CPL) training after a BSc Aviation?",
        a: "Yes. BSc Aviation provides a strong academic foundation for CPL training. CPL flying hours and licensing must be completed separately at DGCA-approved flying schools."
      },
      {
        q: "Can I apply for government aviation jobs like ATC after a BSc Aviation?",
        a: "BSc Aviation graduates may be eligible for AAI ATC and other government aviation roles, subject to meeting age limits, medical standards, and clearing competitive examinations."
      },
      {
        q: "Who should choose MBA Aviation & Airport Management?",
        a: "The MBA program is suitable for graduates aiming for managerial, planning, and leadership roles in airlines, airports, cargo operations, and aviation services."
      },
      {
        q: "Can I pursue higher studies after completing an undergraduate aviation program?",
        a: "Yes. Graduates can pursue an MBA in Aviation, specialised aviation certifications, or related postgraduate programs based on their career goals."
      },
      {
        q: "How does MH Cockpit collaboration benefit aviation students?",
        a: "MH Cockpit supports industry-aligned training, expert sessions, practical exposure, case studies, and academic support, helping students connect academic learning with real aviation operations."
      },
    ],
  },

  // -------------------------
  // Consulting
  // -------------------------
  "/consulting": {
    titleColor: "#FF5959",
    items: [
      {
        q: "What is the first step in engaging MH Cockpit for a consulting project",
        a: "The first step is always a complimentary initial consultation. During this discovery call, we focus on understanding your specific challenges, objectives, and operational context. This allows us to define the project scope together and outline a preliminary roadmap, ensuring we are perfectly aligned before moving forward with a formal proposal."
      },
      {
        q: "How do you approach technology and equipment selection for an aviation training lab?",
        a: "Our approach is vendor-agnostic and needs-driven. We begin by mapping technology requirements directly to your training objectives and curriculum. We then conduct a rigorous evaluation based on key criteria: technical fidelity, lifecycle cost, regulatory compliance, scalability, and after-sales support. This method ensures we recommend the optimal equipment that delivers long-term value, not just the latest product."
      },
      {
        q: "How do you mitigate risks associated with long-term aircraft leasing agreements?",
        a: "We employ a multi-layered risk mitigation strategy. This includes a thorough lessor credit analysis, negotiating favourable return conditions and maintenance reserves, structuring flexible early termination clauses, and ensuring the lease terms align with the aircraft's projected technical lifecycle and residual value. Our goal is to protect your financial and operational flexibility for the entire lease duration."
      },
      {
        q: "How do you approach space planning and layout optimisation for an aviation lab?",
        a: "We use a process-centric design methodology. We start by mapping the intended workflow and user journeys—from student to instructor to maintenance staff. This informs a layout that prioritises safety, efficient movement, and logical progression through training modules. We optimise for factors like clear sightlines, emergency egress, equipment service access, and future expansion, creating a functional and safe learning environment."
      },
      {
        q: "What does your ongoing support and advisory service typically include after a project is complete?",
        a: "Our ongoing support is designed to ensure long-term success. It can include periodic performance reviews of the implemented solutions, regulatory update briefings to keep your facilities and practices compliant, operational efficiency audits, and on-call advisory support for any technical or strategic questions that arise as your operations evolve."
      },
    ],
  },

  // -------------------------
  // Training
  // -------------------------
  "/training": {
    titleColor: "#FF5959",
    items: [
      {
        q: "What makes MH Cockpit different from a regular aviation institute?",
        a: "MH Cockpit is not an independent training centre. We work as an aviation knowledge partner for universities, colleges, and training centres across India. Instead of running our own classes, we help these institutions with industry-based curricula, standardised training methods, modern aviation tools, and academic support so that students receive the same high-quality education wherever they study."
      },
      {
        q: "What qualifications do the trainers and curriculum developers at MH Cockpit have?",
        a: "Our curriculum and training modules are developed by a team of certified pilots, aviation instructors, ground training experts, operational specialists, and academic professionals. Many of our contributors have DGCA-recognised qualifications, real-world airline experience, and expertise in aviation training methodologies—ensuring students learn directly from aviation practitioners."
      },
      {
        q: "How does MH Cockpit ensure industry relevance in its curriculum?",
        a: "Our curriculum has been developed and continuously updated in collaboration with aviators, operational experts, regulatory professionals, and industry trainers. All modules adhere to structured training frameworks aligned with current aviation standards. This provides students with the skills and knowledge aligned with real airline requirements, regulatory expectations, and current industry practice."
      },
      {
        q: "Are simulators and aviation learning technologies part of the training process?",
        a: "Yes, MH Cockpit combines modern aviation tools, digital CBT systems, simulator-based learning environments, and LMS-driven training modules to enhance the learning experience. These technologies help students build operational awareness, understand cockpit procedures, and practice real-world aviation scenarios in a controlled setting."
      },
      {
        q: "Are MH Cockpit programs aligned with DGCA standards and aviation regulations?",
        a: "Absolutely, all training frameworks, academic modules, and licensing guidance offered by MH Cockpit comply with DGCA regulations, aviation educational standards, and the best practices of the industry. We guide students and partner institutions on the correct processes to be followed for PPL, CPL, ATPL, medicals, examinations, and certification pathways."
      },
    ],
  },

  // -------------------------
  // 
  // -------------------------
  // "": {
  //   titleColor: "#FF5959",
  //   items: [
  //   ],
  // },
};

export default faqsByRoute;
